'use client';

import { c as _c } from "react/compiler-runtime";
;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:localcoin": true
    });
  } catch (e) {}
}();
import { RichTextField } from '@prismicio/client';
import clsx from 'clsx';
import React, { ReactElement } from 'react';
import RichText from '@/components/atoms/RichText';
import { MessageQuestionIcon } from '@/public/assets/svg';
import Add from '@/public/assets/svg/add.svg';
import Minus from '@/public/assets/svg/minus.svg';
type FaqItemProps = {
  header: string | null;
  copy: RichTextField | null;
  toggleItem: () => void;
  isOpen: boolean;
  /** Render the icon in the error red accent (e-buy landing) instead of the default primary. */
  highlightIcon?: boolean;
};
const FaqItem: React.FC<FaqItemProps> = t0 => {
  const $ = _c(28);
  const {
    header,
    copy,
    toggleItem,
    isOpen,
    highlightIcon
  } = t0;
  const t1 = highlightIcon ? "text-error-300" : "text-primary-600";
  let t2;
  if ($[0] !== t1) {
    t2 = clsx("hidden h-7 min-w-7 lg:block", t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t2) {
    t3 = <MessageQuestionIcon className={t2} data-sentry-element="MessageQuestionIcon" data-sentry-source-file="index.tsx" />;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== header) {
    t4 = <h3 className="text-body-6 w-full px-4 text-center font-semibold text-gray-600">{header}</h3>;
    $[4] = header;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== isOpen) {
    t5 = isOpen ? <Minus className="h-7 min-w-7" /> : <Add className="h-7 min-w-7" />;
    $[6] = isOpen;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t3 || $[9] !== t4 || $[10] !== t5 || $[11] !== toggleItem) {
    t6 = <button aria-label="faq item" onClick={toggleItem} className="flex w-full items-center py-4">{t3}{t4}{t5}</button>;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
    $[11] = toggleItem;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const t7 = isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0";
  let t8;
  if ($[13] !== t7) {
    t8 = clsx("grid overflow-hidden transition-all duration-300 ease-in-out", t7);
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  const t9 = isOpen ? "opacity-100" : "opacity-0";
  let t10;
  if ($[15] !== t9) {
    t10 = clsx("rich-text text-body-7 pb-2 text-gray-500 transition-opacity duration-300", t9);
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== copy) {
    t11 = <RichText field={copy} data-sentry-element="RichText" data-sentry-source-file="index.tsx" />;
    $[17] = copy;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== t10 || $[20] !== t11) {
    t12 = <div className="overflow-hidden"><div className={t10}>{t11}</div></div>;
    $[19] = t10;
    $[20] = t11;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== t12 || $[23] !== t8) {
    t13 = <div className={t8}>{t12}</div>;
    $[22] = t12;
    $[23] = t8;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== t13 || $[26] !== t6) {
    t14 = <div className="shadow-elevation-4 lg:shadow-elevation-3 mb-4 rounded-[0.625rem] border border-gray-200 px-4 lg:mb-5 lg:px-6 lg:py-2" data-sentry-component="FaqItem" data-sentry-source-file="index.tsx">{t6}{t13}</div>;
    $[25] = t13;
    $[26] = t6;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  return t14;
};
export default FaqItem;